var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"level",class:_vm.extraclass},[_c('div',{staticClass:"level-left"},[_vm._t("default")],2),_c('div',{staticClass:"level-right"},[_vm._t("right")],2)])}
var staticRenderFns = []

export { render, staticRenderFns }